import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    position: 'relative',
    padding: '0',
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius * 2,
    backgroundColor: alpha(theme.palette.common.white, 0.04),
    border: `1px solid ${alpha(theme.palette.text.primary, 0.15)}`,
    '&:hover': {
      borderColor: alpha(theme.palette.text.primary, 0.3),
    },
    '&:focus-within': {
      borderColor: theme.palette.secondary.main,
      boxShadow: `0 0 0 1px ${alpha(theme.palette.secondary.main, 0.3)}`,
    },
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    padding: '2px 0',
    height: 38,
  },
  searchIcon: {
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: theme.palette.text.primary,
    flex: '1 1 auto',
    minWidth: '150px',
  },
  inputInput: {
    paddingLeft: 8,
    paddingTop: 0,
    paddingBottom: 0,
    width: '100%',
  },
  adornmentSeparator: {
    display: 'inline-block',
    width: 1,
    height: 20,
    backgroundColor: alpha(theme.palette.text.primary, 0.1),
    margin: '0 4px',
    flexShrink: 0,
  },
  helpPopover: {
    padding: theme.spacing(2, 2.5),
    maxWidth: 360,
    borderRadius: theme.shape.borderRadius * 2,
  },
  helpTable: {
    borderCollapse: 'collapse',
    width: '100%',
    '& td': {
      padding: theme.spacing(0.375, 0),
      fontSize: '0.8125rem',
      lineHeight: 1.4,
      verticalAlign: 'baseline',
    },
    '& td:first-child': {
      paddingRight: theme.spacing(1.5),
      whiteSpace: 'nowrap',
    },
    '& td:last-child': {
      opacity: 0.5,
    },
  },
  helpCode: {
    fontFamily: 'monospace',
    fontSize: '0.8rem',
    backgroundColor: alpha(theme.palette.text.primary, 0.08),
    padding: '1px 5px',
    borderRadius: 3,
  },
}));
